import { cn } from "@/lib/utils";

/**
 * ⚠️ 骨架屏要**长得像真内容**（同样的行高、同样的块数），
 *    否则内容加载出来时整页跳一下，比转圈还难受。
 */
function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return <div className={cn("bg-muted animate-pulse rounded-md", className)} {...props} />;
}

export { Skeleton };
